<template>
    <div>
        <BCard no-body class="mb-0" >
            <TableFilters :vsPerPage="perPage" :vsPageOptions="perPageOptions" :vsSearchQuery="searchQuery" vsLabel="Añadir movimiento" vsModule="movement" vsRoute="cash-movements-add" />

            <BTable responsive ref="cashTable" class="position-relative" :items="fetchMovements"  :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">
                <template #cell(movement_type)="data">
                    <span>{{ data.item.movement_type.name  }}</span>

                </template>
                <template #cell(amount)="data">
                    {{ formatCurrency(data.item.amount) }}
                </template>

                <template #cell(client)="data">
                    {{ data.item.invoice ? data.item.invoice.student.full_name : (data.item.expense ? data.item.expense.provider.name : '-') }}
                </template>
                <template #cell(date)="data">
                    <span>{{format(new Date (data.item.emit_date), 'dd-MM-yyyy, kk:mm:ss')  }}ds</span>
                </template>
                <template #cell(cash)="data">
                    <BLink :to="{ name: 'cash-view', params: { id: data.item.cash_register_id } }"> {{ data.item.cash_register ? data.item.cash_register.name : '' }} </BLink>
                </template>
                <template #cell(observations)="data">
                    <span>{{ data.item.observations }}</span>
                </template>
                <template #cell(references)="data">
                    <BLink v-if="data.item.invoice_id" :to="{ name: 'invoices-view', params: { id: data.item.invoice_id } }"> {{ data.item.invoice ? data.item.invoice.name : ''  }} </BLink>
                    <BLink v-if="data.item.expense_id" :to="{ name: 'expenses-view', params: { id: data.item.expense_id } }"> {{ data.item.expense ? data.item.expense.name : '' }} </BLink>
                </template>
                
                

                
                <template #cell(actions)="data">
                    <BDropdown variant="link" no-caret>
                        <template #button-content>
                            <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                        </template>
                        <BDropdownItem :to="{ name: 'cash-movements-view', params: { id: data.item.id } }" v-if="ability.can('read', 'movement')">
                            <FeatherIcon icon="FileTextIcon" />
                            <span class="align-middle ml-50">{{$t('Details')}}</span>
                        </BDropdownItem>

                        <BDropdownItem :to="{ name: 'cash-movements-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'movement')">
                            <FeatherIcon icon="EditIcon" />
                            <span class="align-middle ml-50">{{$t('Edit')}}</span>
                        </BDropdownItem>

                        <BDropdownItem @click="deletePopup(data.item.id, 'movements/deleteMovement')" v-if="ability.can('delete', 'movement')">
                            <FeatherIcon icon="TrashIcon" />
                            <span class="align-middle ml-50">{{$t('Delete')}}</span>
                        </BDropdownItem>

                        <!-- <BDropdownItem @click="exportMovements(data.item.id)">
                            <FeatherIcon icon="FileIcon" />
                            <span class="align-middle ml-50">Exportar movimientos</span>
                        </BDropdownItem> -->
                    </BDropdown>
                </template>
            </BTable>

            

            <div class="mx-2 mb-2">
                <BRow>
        
                    <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
                    <span class="text-muted">{{$t('Showing')}} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{$t('of')}} {{ dataMeta.of }} {{$t('entries')}}</span>
                    </BCol>
                    <!-- Pagination -->
                    <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end" >
        
                        <BPagination v-model="currentPage" :total-rows="totalCash" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
                        <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                        </BPagination>
        
                    </BCol>
        
                </BRow>
            </div>



        </BCard>
    </div>

    
</template>
<script>
import { BCard, BDropdown, BDropdownItem, BLink, BRow, BTable, BPagination, BCol} from 'bootstrap-vue';
import { onUnmounted } from '@vue/composition-api';
import TablePagination from '@/components/list/TablePagination.vue';
import TableFilters from '@/components/list/TableFilters.vue';
import cashMovementsListQuery from './cashMovementsListQuery';
import ability from '@/libs/acl/ability';
import popups from '@/hooks/popups';
import store from '@/store';
import cashMovementsModule from '../cashMovementsModule';
import currency from '@/utils/currency'
import { format } from 'date-fns';



export default {
    components: { BCard, BRow, TablePagination, TableFilters, BTable, BLink, BDropdown, BDropdownItem, BPagination, BCol },
    setup(){
        const { deletePopup, successToast, errorToast } = popups()
        const { fetchMovements, tableColumns, perPage, currentPage, totalCash, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, cashTable, refetchData, groupFilter, groupOptions } = cashMovementsListQuery()
        const { formatCurrency } = currency()
        const CASH_MOVEMENTS_MODULE = 'movements'

        if(!store.hasModule(CASH_MOVEMENTS_MODULE)){
            store.registerModule(CASH_MOVEMENTS_MODULE, cashMovementsModule)
        }

        onUnmounted(() => {
            if(store.hasModule(CASH_MOVEMENTS_MODULE)) {
                store.unregisterModule(CASH_MOVEMENTS_MODULE)
            }
        })

        /**
         * Exportar movimiento en CSV
         */
        const exportMovements = function(id){
            axios.post('movements/export', { id: id }).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'listadoMovimientos.csv');
                document.body.appendChild(fileLink);
                fileLink.click();
                successToast('CSV descargado')            
            })
            .catch(error => {
                errorToast('No ha sido posible descargar el CSV: ', error)
            })
        }

        return {
            fetchMovements,
            tableColumns,
            perPage,
            currentPage,
            totalCash,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            cashTable,
            refetchData,
            groupFilter,
            groupOptions,
            ability,
            deletePopup,
            exportMovements, 
            format,
            formatCurrency
        }
    }
}
</script>
